import { render, staticRenderFns } from "./CreateSGObjectStorages.vue?vue&type=template&id=52b4daae"
import script from "./CreateSGObjectStorages.vue?vue&type=script&lang=js"
export * from "./CreateSGObjectStorages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports